/**
 * Caster Options — unified "Add to Cart" handler.
 * Handles both configuration cards and swivel lock add-on cards.
 * Adds to cart via /cart/add.js, then opens minicart drawer.
 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.caster-options-card__add');
  if (!btn || btn.disabled) return;

  var variantId = btn.dataset.variantId;
  if (!variantId) return;

  var minicart = document.querySelector('mini-cart');

  var card = btn.closest('.caster-options-card');
  var qtyInput = card ? card.querySelector('.caster-options-card__qty') : null;
  var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  if (qty < 1) qty = 1;

  var btnLabel = btn.querySelector('span');
  btn.disabled = true;
  if (btnLabel) btnLabel.textContent = 'Adding...';

  var body = {
    items: [{ id: parseInt(variantId, 10), quantity: qty }]
  };

  if (minicart && typeof minicart.getSectionsToRender === 'function') {
    body.sections = minicart.getSectionsToRender().map(function (s) { return s.section; });
    body.sections_url = window.location.pathname;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart add failed');
      return response.json();
    })
    .then(function (data) {
      if (btnLabel) btnLabel.textContent = 'Added';
      btn.classList.add('caster-options-card__add--added');

      if (minicart) {
        minicart.renderContents(data);
        if (!window.themeSettings || !window.themeSettings.redirectToCart) {
          minicart.open(btn);
        }
      }

      if (window.themeSettings && window.themeSettings.redirectToCart) {
        location.href = '/cart';
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:item-add', {
          detail: { items: data.items || [data], context: 'CasterOptions' }
        })
      );

      publish(PUB_SUB_EVENTS.cartItemAdd, {
        source: 'CasterOptions',
        items: data.items || [data]
      });

      setTimeout(function () {
        if (btnLabel) btnLabel.textContent = 'Add to Cart';
        btn.classList.remove('caster-options-card__add--added');
        btn.disabled = false;
      }, 2000);
    })
    .catch(function () {
      if (btnLabel) btnLabel.textContent = 'Add to Cart';
      btn.disabled = false;
    });
});
